<template>
    <Modal v-model="contactModal.show" fullscreen :scrollable="false" :footer-hide="true">
        <div contact class="d-block">
            <div class="d-block" v-if="contactModal.type === 1">
                <h1>{{ $common.config.lang === 'cn' ? '账户注册' : 'Account Register' }}</h1>
                <h3 class="ptb-sm c-gray">{{ $common.config.lang === 'cn' ? '填写表格注册试用下载账户，我们将很快会联系您' : 'Fill out the form to register an account for demo downloading, and we will be in touch as soon as possible' }}</h3>
                <Form>
                    <FormItem>
                        <Select clearable v-model="contactModal.data.pid" size="large" :placeholder="$common.config.lang === 'cn' ? '请选择产品' : 'Choose a product'">
                            <Option :value="item.id" v-for="(item, index) in product" :key="index">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem>
                        <Input size="large" v-model="contactModal.data.name" :placeholder="$common.config.lang === 'cn' ? '请输入姓名' : 'Full name'"/>
                    </FormItem>
                    <FormItem>
                        <Input size="large" v-model="contactModal.data.tel" :placeholder="$common.config.lang === 'cn' ? '请输入电话' : 'Telephone'"/>
                    </FormItem>
                    <FormItem>
                        <Input size="large" v-model="contactModal.data.company" :placeholder="$common.config.lang === 'cn' ? '请输入公司名称' : 'Company name'"/>
                    </FormItem>
                    <FormItem>
                        <Input size="large" v-model="contactModal.data.mail" :placeholder="$common.config.lang === 'cn' ? '请输入邮箱' : 'Email'"/>
                    </FormItem>
                    <FormItem>
                        <Input type="password" size="large" v-model="contactModal.data.password" :placeholder="$common.config.lang === 'cn' ? '请输入密码' : 'password'"/>
                    </FormItem>
                    <FormItem>
                        <Input type="password" size="large" v-model="contactModal.data.enterPassword" :placeholder="$common.config.lang === 'cn' ? '确认密码' : 'Confirm the password'"/>
                    </FormItem>
                </Form>
                <br/>
                <Button long shape="circle" size="large" type="primary" @click="submitForm(contactModal.data, contactModal.type)">{{ $common.config.lang === 'cn' ? '立即注册' : 'Register' }}</Button>
                <Divider>{{ $common.config.lang === 'cn' ? '已有账户' : 'Have Account' }}</Divider>
                <h3 class="align-center">
                    <a @click="contactModal.type = 0">{{ $common.config.lang === 'cn' ? '立即登录' : 'Login Now' }}</a>
                </h3>
            </div>
            <div class="d-block" v-if="contactModal.type === 2">
                <h1>{{ $common.config.lang === 'cn' ? '请求回电' : 'Request a call back' }}</h1>
                <h3 class="ptb-sm c-gray">{{ $common.config.lang === 'cn' ? '填写以下表格，留下您方便接电话的时间，感谢！' : 'Fill in the form as below with time that is convenient for you to receive a call, please. Thank you!' }}</h3>
                <Form>
                    <FormItem>
                        <Input size="large" v-model="contactModal.data.name" :placeholder="$common.config.lang === 'cn' ? '请输入姓名' : 'Full name'"/>
                    </FormItem>
                    <FormItem>
                        <Input size="large" v-model="contactModal.data.tel" :placeholder="$common.config.lang === 'cn' ? '请输入电话' : 'Telephone'"/>
                    </FormItem>
                    <FormItem>
                        <Input size="large" v-model="contactModal.data.company" :placeholder="$common.config.lang === 'cn' ? '请输入公司名称' : 'Company name'"/>
                    </FormItem>
                    <FormItem>
                        <Input v-model="contactModal.data.desc" type="textarea" :rows="4" :placeholder="$common.config.lang === 'cn' ? '方便接听电话的时间' : 'Convenient time for receiving a call'"/>
                    </FormItem>
                </Form>
                <br/>
                <Button long shape="circle" size="large" type="primary" @click="submitForm(contactModal.data, contactModal.type)">{{ $common.config.lang === 'cn' ? '提交' : 'Submit' }}</Button>
            </div>
            <div class="d-block" v-if="contactModal.type === 3">
                <h1>{{ $common.config.lang === 'cn' ? '在线留言' : 'Contact our team' }}</h1>
                <h3 class="ptb-sm c-gray">{{ $common.config.lang === 'cn' ? '我们很乐意回答您的问题。请填写以下表格，收到留言我们会尽快联系您，谢谢！' : 'Our team is happy to answer your questions. Fill out the form and we’ll be in touch as soon as possible. Thank you!' }}</h3>
                <Form>
                    <FormItem>
                        <Input size="large" v-model="contactModal.data.name" :placeholder="$common.config.lang === 'cn' ? '请输入姓名' : 'Full name'"/>
                    </FormItem>
                    <FormItem>
                        <Input size="large" v-model="contactModal.data.tel" :placeholder="$common.config.lang === 'cn' ? '请输入电话' : 'Telephone'"/>
                    </FormItem>
                    <FormItem>
                        <Input size="large" v-model="contactModal.data.mail" :placeholder="$common.config.lang === 'cn' ? '请输入邮箱' : 'Email'"/>
                    </FormItem>
                    <FormItem>
                        <Input v-model="contactModal.data.desc" type="textarea" :rows="4" :placeholder="$common.config.lang === 'cn' ? '留言内容' : 'Request details'"/>
                    </FormItem>
                </Form>
                <br/>
                <Button long shape="circle" size="large" type="primary" @click="submitForm(contactModal.data, contactModal.type)">{{ $common.config.lang === 'cn' ? '提交' : 'Submit' }}</Button>
            </div>
            <div class="d-block" v-if="contactModal.type === 0">
                <h1>{{ $common.config.lang === 'cn' ? '账户登录' : 'Account Login' }}</h1>
                <br/>
                <Form>
                    <FormItem prop="mail">
                        <Input size="large" v-model="contactModal.data.mail" :placeholder="$common.config.lang === 'cn' ? '请输入邮箱' : 'Email'"/>
                    </FormItem>
                    <FormItem prop="password">
                        <Input size="large" type="password" v-model="contactModal.data.password" :placeholder="$common.config.lang === 'cn' ? '请输入密码' : 'Password'"/>
                    </FormItem>
                </Form>
                <br/>
                <Button long shape="circle" size="large" type="primary" @click="submitForm(contactModal.data, contactModal.type)">{{ $common.config.lang === 'cn' ? '登录' : 'Login' }}</Button>
                <Divider>{{ $common.config.lang === 'cn' ? '没有账户' : 'Not Account' }}</Divider>
                <h3 class="align-center">
                    <a @click="contactModal.type = 1">{{ $common.config.lang === 'cn' ? '立即注册' : 'Register Now' }}</a>
                </h3>
            </div>
        </div>
    </Modal>
</template>

<script type="text/javascript">
    export default {
        data() {
            return {
                product: [],
                contactModal: {},
            }
        },
        async created(){
            this.product = [] = await this.$common.product();
            console.log('this.product---------->', this.product);
        },
        mounted() {
            /**
             * type：0登录 1账户注册/免费试用/订购演示 2请求回电 3在线留言 4联系我们
             */
            this.$bus.on('toggleContact', (show, type) => {
                this.contactModal = {
                    show: show,
                    type: type,
                    data: {
                        type: type,
                    },
                };
            });
        },
        methods: {
            async submitForm(data, type){
                console.log('this.submitForm---------->', data, type);
                debugger
                if (!this.verifyData(data, type)) return;
                if (type === 0 || type === 1){
                    data.password = this.$md5(data.password);
                }
                let res;
                if (type === 0){
                    debugger
                    res = await this.$api.postHttp('user/login', data);
                    if (!res.data.success){
                        return this.$Message.error(res.data.errMsg);
                    }
                    this.$Message.success(this.$common.config.lang === 'cn' ? '登录成功' : 'Login Success');
                    localStorage.setItem('account', JSON.stringify(res.data.data));
                    this.$store.state.account = {} = res.data.data;
                }
                if (type === 1){
                    debugger
                    delete data.enterPassword; // 提交时 删除确认密码
                    res = await this.$api.postHttp('user/register', data);
                    if (!res.data.success){
                        return this.$Message.error(res.data.errMsg);
                    }
                    this.$Message.success(this.$common.config.lang === 'cn' ? '注册成功' : 'Register Success');
                    localStorage.setItem('account', JSON.stringify(res.data.data));
                    this.$store.state.account = {} = res.data.data;
                    await this.sendMail(res.data.data);
                }
                if (type === 2 || type === 3){
                    debugger
                    res = await this.$api.postHttp('message', data);
                    if (!res.data.success){
                        return this.$Message.error(res.data.errMsg);
                    }
                    this.$Message.success(this.$common.config.lang === 'cn' ? '操作成功' : 'Success');
                }
                console.log('this.submitForm.res---------->', res);
                this.onCancel();
            },
            onCancel(){
                this.contactModal = {};
            },
            verifyData(data, type){
                debugger
                if (data && type === 0){
                    debugger
                    if (!data.mail || data.mail === ''){
                        this.$Message.error(this.$common.config.lang === 'cn' ? '邮箱不能为空' : 'Emali not be empty');
                        return false;
                    }
                    if (!data.password || data.password === ''){
                        this.$Message.error(this.$common.config.lang === 'cn' ? '密码不能为空' : 'Password not be empty');
                        return false;
                    }
                    return true;
                }
                if (data && type === 1){
                    if (!data.pid || data.pid === ''){
                        this.$Message.error(this.$common.config.lang === 'cn' ? '请选择产品' : 'Choose a product');
                        return false;
                    }
                    if (!data.name || data.name === ''){
                        this.$Message.error(this.$common.config.lang === 'cn' ? '姓名不能为空' : 'Full name not be empty');
                        return false;
                    }
                    if (!data.tel || data.tel === ''){
                        this.$Message.error(this.$common.config.lang === 'cn' ? '电话不能为空' : 'Telephone not be empty');
                        return false;
                    }
                    if (!data.company || data.company === ''){
                        this.$Message.error(this.$common.config.lang === 'cn' ? '公司名称不能为空' : 'Company name not be empty');
                        return false;
                    }
                    if (!data.mail || data.mail === ''){
                        this.$Message.error(this.$common.config.lang === 'cn' ? '邮箱不能为空' : 'Emali not be empty');
                        return false;
                    }
                    if (!data.password || data.password === ''){
                        this.$Message.error(this.$common.config.lang === 'cn' ? '密码不能为空' : 'Password not be empty');
                        return false;
                    }
                    if (data.password !== data.enterPassword){
                        this.$Message.error(this.$common.config.lang === 'cn' ? '两次输入的密码不一致' : 'The two passwords do not match');
                        return false;
                    }
                    return true;
                }
                if (data && type === 2 || type === 3){
                    if (!data.name || data.name === ''){
                        this.$Message.error(this.$common.config.lang === 'cn' ? '姓名不能为空' : 'Full name not be empty');
                        return false;
                    }
                    if (!data.tel || data.tel === ''){
                        this.$Message.error(this.$common.config.lang === 'cn' ? '电话不能为空' : 'Telephone not be empty');
                        return false;
                    }
                    if (type === 2){
                        if (!data.company || data.company === ''){
                            this.$Message.error(this.$common.config.lang === 'cn' ? '公司名称不能为空' : 'Company name not be empty');
                            return false;
                        }
                    }
                    if (type === 3){
                        if (!data.mail || data.mail === ''){
                            this.$Message.error(this.$common.config.lang === 'cn' ? '邮箱不能为空' : 'Emali not be empty');
                            return false;
                        }
                    }
                    return true;
                }
            },

            async sendMail(data){
                console.log('this.sendMail---------->', data);
                let object = {
                    to: data.mail, // 发给谁
                    subject: 'ANYSONUS', // 主题
                    html: '<div style="display: block; width: 640px; margin: 24px auto; padding: 16px; border: 2px solid #009edb; border-radius: 8px;">' +
                        '<h2>您好：' + data.name + ' | ' + data.tel + ' | ' + data.company + '</h2>' +
                        '<p>感谢您加入：' + await this.product.find(it => it.id === data.pid).name + '</p>' +
                        '<p>如果您有什么问题随时通过邮箱联系我们</p>' +
                        '<p>email：<a href="mailto:info@anysonus.com">info@anysonus.com</a></p>' +
                        '<p>我们会在24小时内给您答复</p>' +
                        '<p>也可以登陆我们的网站<a target="_blank" href="http://www.anysonus.com">www.anysonus.com</a>,网站内有我们的其他联系方式。</p>' +
                        '<h3 style="text-align: right;">谢谢！</h3>' +
                        '<h3 style="text-align: right;">ANYSONUS</h3>' +
                    '</div>',
                };
                debugger
                let res = await this.$api.postHttp('common/mailer', object);
                console.log('this.sendMail.res---------->', res);
                this.onCancel();
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ContactForm.vue